// extracted by mini-css-extract-plugin
export default {"userCategories__container":"UserCategories_userCategories__container__BTD3A","userCategories__userCategoryComponents":"UserCategories_userCategories__userCategoryComponents__1MpxE"};